export default "__VITE_ASSET__EggP1mJk__"